import { generateToast } from '@g17eco/molecules/toasts';
import { REQUEST_ACCESS_CONFIG } from './requestAccessConfig';
import type { DataMethod } from './types';

const FLOW_TITLE_OVERRIDES: Partial<Record<DataMethod, string>> = {
  'log-activity': 'By Activity',
  'bulk-upload': 'Bulk Activity Import',
  'from-inventory': 'By Asset',
};

const getFlowTitle = (method: DataMethod, fallbackLabel: string): string => {
  if (method in REQUEST_ACCESS_CONFIG) {
    return REQUEST_ACCESS_CONFIG[method as keyof typeof REQUEST_ACCESS_CONFIG].title;
  }
  return FLOW_TITLE_OVERRIDES[method] ?? fallbackLabel;
};

/**
 * Fires the "We'll be in touch" request-access toast for a selected provider.
 * Used from both Step 1 Automatic provider tiles and Step 2 Request Access
 * provider cards — clicking either surface logs interest without navigating.
 */
export const fireProviderRequestAccessToast = ({
  providerLabel,
  method,
}: {
  providerLabel: string;
  method: DataMethod;
}) => {
  const flowTitle = getFlowTitle(method, providerLabel);
  generateToast({
    color: 'success',
    message: 'This feature is currently not enabled on your account. Please contact support to enable it.',
  });
};
